<div class="modal-container">
  <div class="modal-content">
    <div class="main-section">
      <div class="modal-title">{{ "ORDER_UPDATE_MODAL_PAGE.TITLE" | translate }}</div>
      <div class="modal-subtitle">{{ "ORDER_UPDATE_MODAL_PAGE.SUBTITLE" | translate: { vendor: vendorName } }}</div>
      <ion-textarea [placeholder]="'ORDER_UPDATE_MODAL_PAGE.PLACEHOLDER' | translate" [(ngModel)]="specialRequest"></ion-textarea>
    </div>

    <div class="footer">
      <ion-row>
        <ion-col class="ion-no-padding">
          <ion-button expand="block" (click)="onDismiss()" color="grey" class="custom-button">{{ "CANCEL" | translate }}</ion-button>
        </ion-col>
        <ion-col class="ion-no-padding">
          <ion-button expand="block" (click)="onSubmit()" color="green" class="custom-button" [disabled]="!specialRequest.trim()">
            {{ "SAVE" | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
